import React, { useEffect, useState } from 'react'
import { ReactComponent as InfoIcon } from '../../../assets/svg/InfoIcon.svg'
import { useTranslation } from 'react-i18next'
import CheckedCheckbox from './components/CheckedCheckbox'
import { alertRecipients } from './EmailSection'

const InAppSection = ({ settings, save }) => {
    const { t } = useTranslation()
    const [selectedKeywordOptions, setSelectedKeywordOptions] = useState(settings?.inApp?.keywordsDetected ?? {})
    const [selectedEmotionOptions, setSelectedEmotionOptions] = useState(settings?.inApp?.multipleNegativeEmotions ?? {})

    useEffect(() => {
        if (!!settings) {
            setSelectedKeywordOptions(settings?.inApp?.keywordsDetected ?? {})
            setSelectedEmotionOptions(settings?.inApp?.multipleNegativeEmotions ?? {})
        }
    }, [settings])

    const handleSelection = (type, field) => {
        const data = {
            ...settings,
            inApp: {
                ...settings.inApp,
                [field]: {
                    ...settings.inApp[field],
                    [type]: !settings.inApp[field][type],
                },
            },
        }
        save(data)
        if (field === 'keywordsDetected') {
            setSelectedKeywordOptions(data?.inApp?.keywordsDetected ?? {})
        } else if (field === 'multipleNegativeEmotions') {
            setSelectedKeywordOptions(data?.inApp?.multipleNegativeEmotions ?? {})
        }
    }
    return (
        <div className="rounded-[10px] w-full h-full p-[32px] bg-white">
            <div>
                <div className="flex flex-row justify-between">
                    <p className="font-bold text-[24px] leading-[30px] text-darkenPurple">{t('In-app notifications')}</p>
                    <InfoIcon color="#5E639B" className="hover:cursor-pointer" />
                </div>
                <p className="text-darkenPurple font-medium text-[16px] leading-5 mt-[12px] max-w-[50%]">
                    {t('Here you can manage who will receive the in-app notifications for different types of alerts')}
                </p>
            </div>
            <div className="flex flex-row justify-between">
                <div className="mt-[34px] max-w-[50%]">
                    <div className="flex flex-row gap-[10px]">
                        <p className="font-bold text-darkenPurple">{t('Keyword alerts receipient(s) notifications')}</p>
                        <InfoIcon color="#5E639B" className="hover:cursor-pointer" />
                    </div>
                    {alertRecipients.map((option, index) => (
                        <div key={index} className="flex flex-row items-center mt-[24px] gap-[20px]">
                            <CheckedCheckbox
                                checked={selectedKeywordOptions[option.code]}
                                text={t(option.label)}
                                onClick={() => handleSelection(option.code, 'keywordsDetected')}
                            />
                        </div>
                    ))}
                </div>
                <div className="max-w-[50%] mt-[34px] flex-1">
                    <div className="flex flex-row justify-between items-center gap-[10px]">
                        <p className="font-bold text-darkenPurple">{t('Uncomfortable emotions receipient(s) notifications')}</p>
                        <InfoIcon color="#5E639B" className="hover:cursor-pointer" />
                    </div>
                    {alertRecipients.map((option, index) => (
                        <div key={index} className="flex flex-row items-center mt-[24px] gap-[20px]">
                            <CheckedCheckbox
                                checked={selectedEmotionOptions[option.code]}
                                text={t(option.label)}
                                onClick={() => handleSelection(option.code, 'multipleNegativeEmotions')}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default InAppSection
